<template>
  <article
    class="form_modal_fair">
    <section class="form_modal_fair__container_video fair_invitation fair_invitation_right">
        <div class="fair_invitation__content">
           <div class="fair_invitation__content--right">
                <h3>Enviar invitación a:</h3>
                <div>
                    <label>Nombres</label>
                    <input v-model="mail.name" type="text" name="name" placeholder="Escribe los nombres" v-validate="'required'">
                    <span style="color:red; font-size:12px" v-show="errors.has('name')" class="showError">El campo nombre es requerido.</span>
                </div>
                <div>
                    <label>Correo electrónico</label>
                    <input v-model="mail.mail" type="email" name="email" placeholder="Escribe el correo electrónico" v-validate="'required|email'">
                    <span style="color:red; font-size:12px" v-show="errors.has('email')" class="showError">El campo debe tener un correo electrónico válido.</span>
                </div>
                <!-- <div>
                    <div class="fair_invitation__date">
                        <label>Fecha de nacimiento</label>
                    </div>
                    <div class="mx-input-wrapper">
                        <input v-model="mail.birthday" type="text" name="birthday" placeholder="Escribe la fecha de nacimiento" format="YYYY/MM/DD" v-validate="'required|min:10'" @keydown="onlyNumber" @blur="cleanSpaces()" @input="formatDate()" autocomplete="off" class="mx-input">
                        <i class="mx-icon-calendar">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
                                <path d="M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z"></path>
                            </svg>
                        </i>
                    </div>
                    <span style="color:red; font-size:12px" v-show="errors.has('birthday')" class="showError">Debes ingresar una fecha de nacimiento válida.</span>
                </div> -->
                <div >
                  <label>Género:</label>
                  <v-radio-group
                    v-model="mail.gender"
                    row>
                    <v-radio
                      label="Mujer"
                      value="Femenino"
                      color="#1476FB"
                    ></v-radio>
                    <v-radio
                      label="Hombre"
                      value="Masculino"
                      color="#1476FB"
                    ></v-radio>
                    <v-radio
                      label="Otro"
                      value="Otro"
                      color="#1476FB"
                    ></v-radio>
                  </v-radio-group>
                </div>
                <div>
                    <label>Celular</label>
                    <input v-model="mail.phone" type="text" name="phone" placeholder="Escribe el número de contacto" v-validate="'required|max:14'">
                    <span style="color:red; font-size:12px" v-show="errors.has('phone')" class="showError">El campo debe tener un número de celular válido.</span>
                </div>
                <div>
                    <div class="fair_invitation__date">
                        <label>Fecha y hora de ingreso</label>
                        <arrow-icon
                            color="#21D741"
                            height="16"
                            width="16"
                            style="transform: rotate(180deg); margin-left: 10px"
                            class="fair_invitation__date--icon" 
                        ></arrow-icon>
                    </div>
                    <div class="mx-input-wrapper">
                        <input v-model="text_begin" type="text" name="date_in" class="mx-input" disabled>
                        <i class="mx-icon-calendar">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
                                <path d="M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z"></path>
                            </svg>
                        </i>
                    </div>
                </div>
                <div>
                    <div class="fair_invitation__date">
                        <label>Fecha y hora de salida</label>
                        <arrow-icon
                            color="#ED1C24"
                            height="16"
                            width="16"
                            style="margin-left: 10px;"
                            class="fair_invitation__date--icon"
                        ></arrow-icon>
                    </div>
                    <div class="mx-input-wrapper">
                        <input v-model="text_end" type="text" name="date_out" class="mx-input" disabled>
                        <i class="mx-icon-calendar">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
                                <path d="M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z"></path>
                            </svg>
                        </i>
                    </div>                    
                </div>
                <div class="fair_invitation__content--button_container">
                    <button
                      @click="handleCancel"
                      class="close_button">Cerrar</button>
                    <button
                      @click="formIsInError?'':sendInvitation()">
                      Enviar
                    </button>
                </div>
           </div>
        </div>
    </section>
  </article>
</template>
<script>
import { months } from 'moment'

export default {
    data(){
        return{
            mail: {
                name: '',
                mail: '',
                phone: '',
                gender: '',
                rut: '',
                birthday: '',
                datetime_begin: '2022-05-03 12:00 am',
                datetime_end: '2022-08-30 11:59 pm',
                location_id: '',
            },
            text_begin: '03-05-2022 12:00 am',
            text_end: '30-08-2022 11:59 pm',
            fieldError:'',
            errorOpening: false,
            errorEnding: false,
            spacesInError: false,
            validator: ''
        }
    },
    mounted() {
        this.mail.location_id = this.$route.params.id
    },
    computed:{
        formIsInError(){
            var ans=false
            let fields=[]
            if(this.mail.name.length==0){
                fields.push("'Ingresa nombre'");
            }
            if(this.mail.mail.length==0){
                fields.push("'Ingresa correo electrónico'");
            }
            if(this.mail.gender.length==0){
                fields.push("'Selecciona género'");
            }
            // if(this.mail.birthday.length==0 || this.mail.birthday.length<10){
            //     fields.push("'Fecha de nacimiento'");
            // }
            if(this.mail.phone.length==0){
                fields.push("'Ingresa telefono'")
            }
            if(this.mail.datetime_begin != null && this.mail.datetime_begin.length==0){
                fields.push("'Fecha Ingreso'")
            }
            if(this.mail.datetime_end != null && this.mail.datetime_end.length==0){
                fields.push("'Fecha Salida'")
            }
            if(this.scheduleIsInError){
                fields.push("''")
            }
            if(fields.length>0){
                if(fields.length==2){
                this.fieldError=fields.join(" y ")
                }else{
                this.fieldError=fields.join(" , ")
                }
                this.$validator.validateAll()
                ans=true
            }else{
                this.fieldError=""
            }
            return ans
        },
        scheduleIsInError(){
            var ans=false
            if(this.errorOpening||this.errorEnding||this.spacesInError){
                ans=true
            }
            return ans
        }        
    },
    watch: {        
    },
    methods:{
        handleCancel(){
            this.$emit('handleCancelModalRewardUser', false)
        },
        sendInvitation(){
            if(this.mail.phone === ''){
                this.updateAlertMessage('Por favor ingresa el número de celular');
                this.updateIsInAlert(true);
            }else{
                this.mail.rut = this.mail.phone.replace(/\-|\./g,"")
                if (this.mail.mail !== this.getEmailUser()) {
                    if (this.getDeviceId() === '' || this.getDeviceId() === null || this.getDeviceId() === 'null'){
                        this.buildDeviceId()
                    }
                    try {
                        let time_send = new Date().getTime()
                        this.$http.post('app/bookings/create_reward_user',{
                            user_id: this.getUserId(),
                            time_send: time_send,
                            device_id: this.getDeviceId(),
                            user_id_encrypt: this.getUserIdEncrypt(),
                            begin: new Date(this.mail.datetime_begin).toLocaleString("sv", {timeZoneName: "short"}).substring(0,16),
                            end: new Date(this.mail.datetime_end).toLocaleString("sv", {timeZoneName: "short"}).substring(0,16),
                            begin_server: new Date(this.mail.datetime_begin).toISOString().replace('T',' ').replace('Z',''),
                            end_server: new Date(this.mail.datetime_end).toISOString().replace('T',' ').replace('Z',''),
                            email: this.mail.mail.toLowerCase(),
                            name: this.mail.name,
                            phone: this.mail.phone,
                            gender: this.mail.gender,
                            rut: this.mail.rut,
                            location_id: this.mail.location_id
                        },{
                        headers:{
                            "X-Device-ID" : this.getDeviceId(),
                            "Authorization" : 'Bearer ' + this.getUserToken()
                        }
                        })
                        .then(function(response){
                            console.log('SEND INVITATION ',response)
                            this.handleCancel();
                            if(response.body.ans == "Se ha realizado la invitación con éxito"){
                                this.updateAlertMessage("Se ha enviado la cortesía con éxito");
                            }else{
                                this.updateAlertMessage(response.body.ans);
                            }
                            this.updateIsInAlert(true);
                            if(response.body.meta != undefined && response.body.meta != null){
                                if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                    this.checkToken(response.body.meta.authentication_token)
                                }
                            }
                            }, function(response){
                            if (response.status==401) {
                                alert("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
                            }if (response.status==400) {
                                this.updateAlertMessage(response.body.ans);
                                this.updateIsInAlert(true);
                            }else{
                                // alert(response.body.errors[0].details);
                                this.updateAlertMessage(response.body.errors[0].details);
                                this.updateIsInAlert(true);
                            }
                            if(response.body.meta != undefined && response.body.meta != null){
                                if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                    this.checkToken(response.body.meta.authentication_token)
                                }
                            }
                        })
                    } catch (e) {
                        alert(e.message)
                    }
                } else {
                    this.updateAlertMessage('No se puede generar una invitación para el mismo usuario')
                    this.updateIsInAlert(true);
                }
            }
        },
        validateRut(indexed_rut){
            console.log(indexed_rut);
            var rut = indexed_rut.toString().replace(/\.|\-/g,'').split('').reverse().map(Number)
            var multiplier = 2
            var sum = 0
            var validator = null
            for (var i = 0; i < rut.length; i++) {
                rut[i] = rut[i]*multiplier
                sum = sum + rut[i]
                if (multiplier < 7) {
                multiplier += 1
                } else {
                multiplier = 2
                }
            }
            validator = 11 - (sum%11)
            console.log(validator);
            switch (validator) {
                case 11:
                return '0'
                break;
                case 10:
                return 'K'
                break;
                default:
                return validator.toString().toUpperCase();
                break;
            }
        },
        formatDate(){
            var dateValue = this.mail.birthday;
            if (/\D$/.test(dateValue)){
                dateValue = dateValue.substr(0, dateValue.length - 3);
            }
            dateValue=dateValue.replaceAll(" ","");
            var arr = dateValue.split('-');

            if(arr[0])arr[0]=this.formatNumber(arr[0],3,31);
            if(arr[1])arr[1]=this.formatNumber(arr[1],1,12);

            var result= arr.map(function(val,index) {
                return val.length == 2 && index < 2 ? val + ' - ' : val;
            });
            this.dateValidation(result)                    
        },
        formatNumber(num,from,limit){
            num=Number(num)>from&&Number(num)<10&&num.length==1?"0"+num:num;
            if(Number(num)>limit){
                num=num.substr(1, 2);
                num=Number(num)>from&&Number(num)<10&&num.length==1?"0"+num:num;
            }
            return num;
        },
        cleanSpaces(){
            this.mail.birthday = this.mail.birthday.replaceAll(" ","")
        },
        dateValidation(result){
            let day = result[0].substring(0,2)
            let month = !result[1] ? null : result[1].substring(0,2)
            let year = !result[2] ? null : result[2].substring(0,4)
            if (result[0] && !result[1]){
                this.mail.birthday = day == "00" ? '' : result.join('').substr(0, 14)
            }else if (result[0] && result[1] && !result[2]){
                if (month == "00"){
                    this.mail.birthday = result[0].substr(0, 14)
                }else{
                    if(parseInt(day) > 29 && parseInt(month) == 2){
                        this.mail.birthday = result[0].substr(0, 14)
                    }else{
                        this.mail.birthday = result.join('').substr(0, 14)
                    }
                }
            }else if(result[0] && result[1] && result[2]){
                if (year.length == 4){
                    let javascript_month = parseInt(month) == 1 ? 0 : (parseInt(month) - 1)
                    if(this.isValidDate(parseInt(day), javascript_month, parseInt(year))){
                        let actual_date = new Date()
                        let entered_date = new Date(year+'/'+month+'/'+day)
                        if(actual_date <= entered_date){
                            this.mail.birthday = ''
                        }else{
                            this.mail.birthday = result.join('').substr(0, 14)
                        }
                    }else{
                        this.mail.birthday = result[0].substr(0, 14)
                    }
                }
            }
        },
        isValidDate(d, m, y){
            return m >= 0 && m < 12 && d > 0 && d <= this.daysInMonth(m, y);
        },
        daysInMonth(m, y) { // month is 0 indexed: 0-11
            switch (m) {
                case 1 :                    
                    return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
                case 8 : case 3 : case 5 : case 10 :
                    return 30;
                default :
                    return 31
            }
        },
        onlyNumber($event){
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && (keyCode < 96 || keyCode > 105) && keyCode !== 8 && keyCode !== 9) {
                $event.preventDefault();
            }
        },
        buildDeviceId(){
            var uuid
            if(localStorage.device_id != undefined &&
                localStorage.device_id != null &&
                localStorage.device_id != '' &&
                localStorage.device_id != 'null'){
                uuid = localStorage.device_id
            } else {
                uuid = this.$uuid.v1()
                localStorage.device_id = uuid
            }
            console.log("DEVICE ID!!!!!!!!!!!!!!!!!!!!!!");
            console.log(uuid);
            this.updateDeviceId(uuid);
            return uuid
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/invitations/ModalRewardUser.vue